import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, LayoutDashboard, FileText, Library } from "lucide-react";

const NavItem = ({ to, icon: Icon, label, active, testid }) => (
  <Link
    to={to}
    data-testid={testid}
    className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors ${
      active
        ? "bg-[#0f1c3f] text-white"
        : "text-[#2c3540] hover:bg-[#f0ece1]"
    }`}
  >
    <Icon size={15} />
    <span className="font-medium tracking-wide">{label}</span>
  </Link>
);

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const { pathname } = useLocation();

  return (
    <div className="min-h-screen tram-grain">
      <header className="border-b border-[#e2ddd3] bg-white/85 backdrop-blur-md sticky top-0 z-40">
        <div className="max-w-[1400px] mx-auto px-6 h-16 flex items-center gap-8">
          <Link to="/" className="flex items-center gap-3" data-testid="tram-logo-link">
            <div className="w-9 h-9 rounded-md bg-[#0f1c3f] text-white flex items-center justify-center font-serif-display text-lg font-bold tracking-wider">
              TR
            </div>
            <div className="leading-tight">
              <div className="font-serif-display text-[19px] font-semibold text-[#0f1c3f] tracking-widest">
                TRAM
              </div>
              <div className="text-[9px] font-mono-tram tracking-[0.35em] text-[#7a6b5d] uppercase -mt-0.5">
                Recruitment · Est 2024
              </div>
            </div>
          </Link>
          <nav className="flex items-center gap-1 ml-4">
            <NavItem
              to="/dashboard"
              icon={LayoutDashboard}
              label="Dashboard"
              active={pathname === "/dashboard"}
              testid="nav-dashboard"
            />
            <NavItem
              to="/library"
              icon={Library}
              label="CV Library"
              active={pathname.startsWith("/library")}
              testid="nav-library"
            />
          </nav>
          <div className="ml-auto flex items-center gap-3">
            <div className="text-right leading-tight hidden sm:block">
              <div className="text-[11px] overline">Signed in</div>
              <div className="text-sm font-semibold text-[#0f1c3f]" data-testid="user-name">
                {user?.name || user?.email}
              </div>
            </div>
            <button
              onClick={() => {
                logout();
                nav("/login");
              }}
              data-testid="logout-button"
              className="p-2 rounded-md border border-[#e2ddd3] hover:bg-[#f0ece1] text-[#0f1c3f]"
              title="Sign out"
            >
              <LogOut size={16} />
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-[1400px] mx-auto px-6 py-10">{children}</main>
    </div>
  );
}
